import { Routes } from '@angular/router';
import { RsNumberSelectionComponent } from '@core/components';
import { NotFoundComponent } from '@core/components/not-found/not-found.component';
import { isLeasingCompanyUserGuard } from '@shared/guards/leasing-company/leasing-company.guard';
import { isAdminGuard } from '@shared/guards/admin/admin.guard';
import { adminRoutes } from '@app/admin/admin.routes';
import { leasingCompanyRoutes } from '@app/leasing-company/leasing-company.routes';
import { supplierRoutes } from '@app/supplier/supplier.routes';
import { isSupplierUserGuard } from '@shared/guards/supplier/supplier.guard';
import { oldUiWarningGuard } from '@shared/guards/old-ui/old-ui-warning.guard';
import OldUiWarningComponent from '@core/components/old-ui-warning/old-ui-warning.component';
import { isFeatureEnabled } from '@core/feature-flag/feature-flag.guard';
import { rsNumberSelectionGuard } from '@core/components/rs-number-selection/rs-number-selection.guard';
import { currentUserExistsGuard } from '@shared/guards/current-user-exists/current-user.guard';

export const appRoutes: Routes = [
  {
    pathMatch: 'full',
    path: '',
    redirectTo: 'rs-number',
  },
  {
    pathMatch: 'full',
    path: 'rs-number',
    component: RsNumberSelectionComponent,
    canActivate: [rsNumberSelectionGuard()],
  },
  {
    path: 'admin',
    children: adminRoutes,
    canActivate: [currentUserExistsGuard, isAdminGuard(), isFeatureEnabled('new-ui.scope.admin', '/old-ui')],
  },
  {
    path: 'leasing-company',
    children: leasingCompanyRoutes,
    canActivate: [currentUserExistsGuard, isLeasingCompanyUserGuard(), isFeatureEnabled('new-ui.scope.leasing-company', '/old-ui')],
  },
  {
    path: 'supplier',
    children: supplierRoutes,
    canActivate: [currentUserExistsGuard, isSupplierUserGuard(), isFeatureEnabled('new-ui.scope.supplier', '/old-ui')],
  },
  {
    path: 'old-ui',
    canActivate: [oldUiWarningGuard],
    component: OldUiWarningComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
    canActivate: [currentUserExistsGuard],
  },
];
